module.exports = __webpack_public_path__ + "img/entratainment-and-showbiz-icon.f38f480b.svg";